const FEED_SELECTOR = '.posts-feed';
const NEXT_PAGE_SELECTOR = '.pagination__next';
const LOAD_MORE_SELECTOR = '.pagination__load-more';
const POST_SELECTOR = '.post-card';
const PAGINATION_SELECTOR = '.pagination';
const PAGINATION_NAV_SELECTOR = '.pagination nav';

export enum PaginationType {
  Classic = 'Classic',
  InfiniteScroll = 'Infinite Scroll',
  LoadMore = 'Load More',
}

export async function setupInfiniteScroll() {
  const config = {
    path: NEXT_PAGE_SELECTOR,
    append: POST_SELECTOR,
    hideNav: PAGINATION_SELECTOR,
    history: false,
    historyTitle: false,
  };
  await initializeInfiniteScroll(config);
}

export async function setupLoadMoreScroll() {
  const config = {
    path: NEXT_PAGE_SELECTOR,
    append: POST_SELECTOR,
    scrollThreshold: false,
    hideNav: PAGINATION_NAV_SELECTOR,
    button: LOAD_MORE_SELECTOR,
    history: false,
    historyTitle: false,
  };
  await initializeInfiniteScroll(config);
}

async function initializeInfiniteScroll(config: Record<string, any>) {
  const $feed = document.querySelector(FEED_SELECTOR);

  if ($feed) {
    const InfiniteScroll = await import('infinite-scroll');
    new InfiniteScroll($feed, config);
    return true;
  }
}